import { useEffect, useMemo } from "react";
import { useQuery } from "@apollo/client";
import { LenssourceModelLensSourceType } from "../../../gql-generated/types";
import {
    type GetCachedLensSourceListQuery,
    type GetCachedLensSourceListQueryVariables,
    getCachedLensSourceList,
} from "../api/queries";
import { useLensSourcePaginationContext } from "../hooks";

export function useLensSources(type: LenssourceModelLensSourceType) {
    const { firstLoad, loading, isLastPage, loadMore, reset } = useLensSourcePaginationContext(type);

    const { data } = useQuery<GetCachedLensSourceListQuery, GetCachedLensSourceListQueryVariables>(
        getCachedLensSourceList,
        { variables: { lensSourceType: type }, fetchPolicy: "cache-only" },
    );

    useEffect(() => {
        firstLoad();
    }, [firstLoad]);

    const sources = useMemo(() => data?.getLensSourceList?.lensSourceList || [], [data]);

    return {
        loading,
        isLastPage,
        loadMore,
        sources,
        reset,
    };
}
